import { useTranslation } from '@zurich/common/hooks';
import { Stack, Typography } from '@zurich/ui/atoms';
import { styled } from '@zurich/ui/legacy/utils';
import { PhotoTipImg } from './PhotoTipImg';

type Tip = {
  title: string;
  body: string;
  correctPhoto?: string;
  incorrectPhoto?: string;
};

const tips: Tip[] = [
  {
    title: 'vsga:tips.photoQuality',
    body: 'vsga:tips.photoQualitybody',
  },
  {
    title: 'vsga:tips.light',
    body: 'vsga:tips.lightBody',
    correctPhoto: '/images/vsga/auto-gut.jpg',
    incorrectPhoto: '/images/vsga/auto-dunkel.jpg',
  },
  {
    title: 'vsga:tips.focus',
    body: 'vsga:tips.focusBody',
    correctPhoto: '/images/vsga/auto-gut.jpg',
    incorrectPhoto: '/images/vsga/auto-unscharf.jpg',
  },
  {
    title: 'vsga:tips.section',
    body: 'vsga:tips.sectionBody',
    correctPhoto: '/images/vsga/auto-gut.jpg',
    incorrectPhoto: '/images/vsga/auto-ausschnitt.jpg',
  },
  {
    title: 'vsga:tips.motif',
    body: 'vsga:tips.motifBody',
    correctPhoto: '/images/vsga/auto-motiv-gut.jpg',
    incorrectPhoto: '/images/vsga/auto-motiv-schlecht.jpg',
  },
  {
    title: 'vsga:tips.frameFilling',
    body: 'vsga:tips.frameFillingBody',
    correctPhoto: '/images/vsga/auto-bildfuellend.jpg',
    incorrectPhoto: '/images/vsga/auto-bildfuellend-schlecht.jpg',
  },
];

export function PhotoTips() {
  const { t } = useTranslation();

  return (
    <StackStyled maxWidth="600px" width="100%" minHeight="72vH" gap={3}>
      {tips.map((tip) => (
        <Stack gap={2} key={tip.title}>
          <Typography variant="body1 medium" color="darkBlue">
            {t(tip.title)}
          </Typography>
          <Typography variant="body2 light" color="darkBlue">
            {t(tip.body)}
          </Typography>
          {tip.correctPhoto && tip.incorrectPhoto && (
            <Stack direction="row" justifyContent="space-between">
              <PhotoTipImg
                src={tip.correctPhoto}
                alt={t('altProp.correct')}
                correct
              />
              <PhotoTipImg
                src={tip.incorrectPhoto}
                alt={t('altProp.incorrect')}
                correct={false}
              />
            </Stack>
          )}
        </Stack>
      ))}
    </StackStyled>
  );
}

const StackStyled = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2, 2),
}));
